// src/config/featureFlags.js
//
// Chaves liga/desliga de funcionalidades em transição.

// FATURAMENTO PELO FINANCEIRO
// false → comportamento antigo: ao fechar chamado "Com Cobrança", o técnico escolhe NF/sem NF e a Intranet lança no VHSYS na hora.
// true  → o técnico só fecha (valores e ID do VHSYS do cliente continuam obrigatórios); a cobrança vai para
//         "A Faturar" no Financeiro, que gera o lançamento no VHSYS (individual ou agrupado).
// Ligar SOMENTE depois que as funções financeiroFaturar / financeiroAgrupar estiverem publicadas e testadas.
export const FATURAMENTO_PELO_FINANCEIRO = true;
